var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.71,19.2c1.41,0,2.56-1.15,2.56-2.56s-1.15-2.56-2.56-2.56l-7.31-.02v5.25c.24-.06,.5-.1,.76-.1h6.54Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.04,25.5h-8.21c-.15,0-.29,0-.44-.03v8.55h8.64c1.41,0,2.56-1.15,2.56-2.56v-3.39c0-1.41-1.15-2.56-2.56-2.56Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,21.62c1.01-1.4,1.6-3.12,1.6-4.98,0-4.72-3.84-8.56-8.56-8.56h-6.46l-3.76-.11c-.84-.04-1.6,.28-2.18,.85s-.91,1.34-.91,2.15v26.07c0,.8,.32,1.56,.89,2.13,.56,.56,1.32,.87,2.11,.87h.02l11.62-.02c4.72,0,8.56-3.84,8.56-8.56v-3.39c0-2.57-1.14-4.88-2.93-6.45Zm-14.27-7.56l7.31,.02c1.41,0,2.56,1.15,2.56,2.56s-1.15,2.56-2.56,2.56h-6.54c-.26,0-.52,.03-.76,.1v-5.25Zm11.21,17.4c0,1.41-1.15,2.56-2.56,2.56h-8.64v-8.55c.14,.02,.29,.03,.44,.03h8.21c1.41,0,2.56,1.15,2.56,2.56v3.39Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBold);
export default __webpack_public_path__ + "static/media/ico-bold.197d1b0c63fd4b2d7661e41f8b315f59.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;